/*
 * Copyright (C) 2005 - 2025 Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

/*global __webpack_public_path__ */

import jrsConfigs from 'js-sdk/src/jrs.configs';

// Used to configure public path of the js file in runtime
// since js path has specific prefix
// see https://webpack.js.org/guides/public-path/#on-the-fly
// eslint-disable-next-line no-undef
__webpack_public_path__ = `${jrsConfigs.runtimeContextPath}/scripts/`;
